import placeholder from './img/placeholder.png'
import image3 from './img/新闻3的图片.png'
import image4 from './img/新闻4的图片.png'
import image6 from './img/新闻6的图片.png'
import image8 from './img/新闻8的图片.png'

export const news = [
  {
    id: 12,
    date: '2025-04-05 14:20:59',
    title: "Federal Sustainability Plan: Catalyzing America's Clean Energy Industries and Jobs",
    link: 'https://www.sustainability.gov/archive/biden46/federalsustainabilityplan/index.html',
    image: placeholder,
  },
  {
    id: 13,
    date: '2025-04-05 14:23:31',
    title:
      'FACT SHEET: Biden-Harris Administration Leads by Example, Leveraging the Federal Government to Catalyze Clean Energy Jobs and Cut Costs and Pollution',
    link: 'https://bidenwhitehouse.archives.gov/briefing-room/statements-releases/2024/12/09/fact-sheet-biden-%E2%81%A0harris-administration-leads-by-example-leveraging-the-federal-government-to-catalyze-clean-energy-jobs-and-cut-costs-and-pollution/',
    image: placeholder,
  },
  {
    id: 14,
    date: '2025-04-05 14:25:47',
    title: 'Governor Newsom Updates the Roadmap to California’s Clean Energy Future',
    link: 'https://www.gov.ca.gov/2023/05/25/governor-newsom-updates-the-roadmap-to-californias-clean-energy-future/',
    image: image3,
  },
  {
    id: 15,
    date: '2025-04-05 14:26:20',
    title: 'California Releases World’s First Plan to Achieve Net-Zero Carbon Pollution',
    link: 'https://www.gov.ca.gov/2022/11/16/california-releases-worlds-first-plan-to-achieve-net-zero-carbon-pollution/',
    image: image4,
  },
  {
    id: 16,
    date: '2025-04-05 14:26:49',
    title: 'Clean Energy and Pollution Reduction Act (SB 350)',
    link: 'https://www.energy.ca.gov/rules-and-regulations/energy-suppliers-reporting/clean-energy-and-pollution-reduction-act-sb-350',
    image: placeholder,
  },
  {
    id: 17,
    date: '2025-04-05 14:27:19',
    title: '2025 California Energy Code Implementation',
    link: 'https://www.energy.ca.gov/sites/default/files/2024-12/2025_Energy_Code_Summary_ADA.pdf',
    image: image6,
  },
  {
    id: 18,
    date: '2025-04-05 14:27:51',
    title: 'Nature-Based Solutions Climate Targets',
    link: 'https://resources.ca.gov/Initiatives/Expanding-Nature-Based-Solutions',
    image: placeholder,
  },
  {
    id: 19,
    date: '2025-04-05 14:28:12',
    title: 'Vermont Might Change How It Accounts for Climate-Damaging Emissions. Here’s What’s at Stake',
    link: 'https://insideclimatenews.org/news/31032025/vermont-greenhouse-gas-emissions-climate-laws/',
    image: image8,
  },
]
